import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import StockSubmitSection from 'modules/StockSubmitSection';
import { isAuthenticated as isAuthenticatedSelector } from 'selectors/app';
import ExchangeWorkingCountdown from 'components/ExchangeWorkingCountdown';
import { workingHoursHoc, WorkingHours } from 'queries/ExchangeWorkingHours/hoc';
import StockLandingAuthentication from 'components/StockLandingAuth';
import { RootState } from 'reducers';
import { featureFlagsSelector } from 'selectors/config';
import DisabledStockNotify from 'components/DisabledStockNotify';

interface Props {
  id: number;
  symbol: string;
  disabled?: boolean;
}

const selector = (state: RootState) => ({
  ...isAuthenticatedSelector(state),
  ...featureFlagsSelector(state),
});

type Enhanced = Props & WorkingHours & ReturnType<typeof selector>;

const enhance = compose<Enhanced, Props>(workingHoursHoc, connect(selector));

const InvestSection: React.FC<Enhanced> = ({
  id,
  isAuthenticated,
  isOnline,
  from,
  to,
  symbol,
  refetchWorkingHours,
  disabled,
}) => {
  if (!isAuthenticated) {
    return <StockLandingAuthentication align="center" symbol={symbol} />;
  }

  if (disabled) {
    return <DisabledStockNotify />;
  }

  if (!isOnline && from && to) {
    return (
      <ExchangeWorkingCountdown
        template="landing"
        from={from}
        to={to}
        onExceed={refetchWorkingHours}
      />
    );
  }

  return <StockSubmitSection id={id} form="stock-landing-higher-form" />;
};

export default enhance(InvestSection);
